<button
  mat-icon-button
  (click)="openDialog()"
  class="navbar-button-icon"
  aria-label="open dialogo"
>
  <mat-icon
    svgIcon="bell"
    [matBadge]="(historicoAtualizacoes$ | async).length"
    [matBadgeHidden]="
      historicoAtualizacoes$ && (historicoAtualizacoes$ | async).length <= 0
    "
    matBadgeColor="warn"
    matBadgeSize="small"
    matBadgePosition="after"
  ></mat-icon>
</button>
